var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M3.8699 6.49023L2.0999 8.26023L11.9999 18.1602L21.8999 8.26023L20.1299 6.49023L11.9999 14.6202L3.8699 6.49023Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }